export const EDMONTON_LOCATIONS = [
  {
    uuid: 'cf4d054f-6b21-4e4b-9104-543f0e9ff7c6',
    city: 'Edmonton',
    type: 'public',
    name: 'Victoria Golf Course',
    address: '12130 River Valley Rd, Edmonton, AB, T5J 2G7',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '69599fb6-e7c6-4bf8-b53c-1e0d298f77c2',
    city: 'Edmonton',
    type: 'private',
    name: 'Royal Mayfair Golf Club',
    address: '9450 Groat Rd NW, Edmonton, AB, T6G 2T5',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '93c36034-7577-40d0-ba30-5d4ccbe30ad8',
    city: 'Edmonton',
    type: 'public',
    name: 'River Ridge Golf & Country Club',
    address: '5685 Windermere Blvd SW, Edmonton, AB, T6W 0S6',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'bfb76f86-0de6-493b-b446-878cff864c79',
    city: 'Edmonton',
    type: 'public',
    name: 'The Quarry Golf Club',
    address: '945-167 Avenue NE, Edmonton, AB, T5Y 0P6',
    holes: 27,
    drivingRange: true,
  },
  {
    uuid: '2b77e4ee-385d-46d3-b398-8e7df8daba67',
    city: 'Edmonton',
    type: 'public',
    name: 'Cougar Creek Golf Resort',
    address: '2519 Highway 16, Edmonton, AB, T5T 5L4',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '69027f1c-d5cc-459c-885c-e589d0090731',
    city: 'Edmonton',
    type: 'public',
    name: 'Lewis Estates Golf Course',
    address: '260 Suder Greens Dr NW, Edmonton, AB, T5T 4B7',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '0c74013b-623f-4424-8753-884447da59c1',
    city: 'Edmonton',
    type: 'public',
    name: 'Dragons Head Golf',
    address: '12240-199 St, Edmonton, AB, T5V 1T8',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '6d7f5826-747e-45c5-9c6a-ea761d60515b',
    city: 'Edmonton',
    type: 'public',
    name: 'Jagare Ridge Golf Club',
    address: '14931 Ellerslie Rd SW, Edmonton, AB, T6W 1A4',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '25ea370b-acf5-480b-93d3-c4bb31547b44',
    city: 'Edmonton',
    type: 'public',
    name: 'Riverside Golf Club',
    address: '8630 Rowland Road, Edmonton, AB, T5J 2T6',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: 'abf3ef1a-1af2-47ea-8352-b409ca6012ac',
    city: 'Edmonton',
    type: 'private',
    name: 'Glendale Golf & Country Club',
    address: '12410 199 St NW, Edmonton, AB, T5V 1T8',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'a8585bfb-ec19-47cf-acb5-b4f3681f8250',
    city: 'Edmonton',
    type: 'private',
    name: 'Highlands Golf Club',
    address: '6603 Ada Blvd, Edmonton, AB, T5W 4N5',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '164dc093-ae9a-4411-b7ca-d19f2af16be8',
    city: 'Edmonton',
    type: 'private',
    name: 'Edmonton Country Club',
    address: '6201 Country Club Rd, Edmonton, AB, T6M 2J6',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '67b2eb92-9a07-4eed-b61b-f04938972794',
    city: 'Edmonton',
    type: 'private',
    name: 'Windermere Golf & Country Club',
    address: '19110 Ellerslie Road SW, Edmonton, AB, T6W 1A5',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '7c04d520-1e02-4af7-aac8-1dc149b9e2b2',
    city: 'Edmonton',
    type: 'public',
    name: 'Twin Willows Golf Club',
    address: '14110 156th Street NW, Edmonton, AB, T6V 1J2',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '76ca75e8-362b-47b1-a5fe-0a27e42d5ffb',
    city: 'Edmonton',
    type: 'public',
    name: 'Golden West Golf Course',
    address: '16410-137th Avenue, Edmonton, AB, T5L 4H8',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'dc447019-e854-4275-b712-8d56146d948e',
    city: 'Edmonton',
    type: 'public',
    name: 'Kinsmen Park Pitch & Putt',
    address: '5408 111th Ave. St., Edmonton, AB, T5R 2T9',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: 'a9f580d3-db68-4071-903f-7443ba86e603',
    city: 'Edmonton',
    type: 'private',
    name: 'The Derrick Golf & Winter Club',
    address: '3500 119 St NW, Edmonton, AB, T6J 5P5',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'b6f93c07-59cb-4d7b-b52a-b285ae8bf128',
    city: 'Edmonton',
    type: 'public',
    name: 'Rundle Park Golf Course',
    address: '2902 118th Ave, Edmonton, AB, T5S 2M5',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '265db0b8-8183-4168-b716-4f0e0221d8c6',
    city: 'Edmonton',
    type: 'public',
    name: 'Raven Crest Golf & Country Club',
    address: '251 153 Ave, Edmonton, AB, T5Y 6K8',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '6e8f66c4-336d-4682-9a17-362ebd14b2c9',
    city: 'Edmonton',
    type: 'public',
    name: 'Pioneer Meadows Golf Course',
    address: '34th Street, Edmonton, AB, T6K 4C2',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'c1cf507c-7644-4427-b217-88046ebb4554',
    city: 'Edmonton',
    type: 'public',
    name: 'Garrison Memorial Golf & Curling Club',
    address: '298 Falaise Avenue, Edmonton, AB, T0A 2H0',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'd7731de3-e8b7-45ec-9091-f756a592e191',
    city: 'Edmonton',
    type: 'public',
    name: 'Mill Woods Golf Club',
    address: '4540-50th Street, Edmonton, AB, T6L 6P6',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'e6dda9a9-de50-4edd-9db5-116c33d3952e',
    city: 'Edmonton',
    type: 'private',
    name: 'Petroleum Golf & Country Club',
    address: '215 St and 9 Ave, Edmonton, AB, T7Y 1B1',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '23a5fa39-abc2-4d93-bd4d-aba98d8f316b',
    city: 'Edmonton',
    type: 'public',
    name: 'Montgomery Glen Golf & Country Club',
    address: 'AB-13 & AB-2A & Township Rd 464, Edmonton, AB, T5G 0X7',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '16d07f60-863f-4227-9121-174900e934b4',
    city: 'Edmonton',
    type: 'public',
    name: 'Rich Valley Resort Golf Course & RV Park',
    address: '204, 10123 157 Street, Edmonton, AB, T5P 2T9',
    holes: 9,
    drivingRange: false,
  },
  {
    uuid: '9f025ca5-a5e9-4bd2-aabd-419f0d61b238',
    city: 'Edmonton',
    type: 'public',
    name: 'Seven Oaks Golf Course',
    address: '11310-30 Avenue SW, Edmonton, AB, T0B 4C0',
    holes: 9,
    drivingRange: true,
  },
  {
    uuid: 'cd8a1b6f-e4fd-4dd9-8999-9a2202d29553',
    city: 'Edmonton',
    type: 'public',
    name: 'Sandpiper Golf & Country Club',
    address: '26029 Meadowview Dr, Sturgeon County, AB, T8T 0K8',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'c006ac85-0473-454c-bc2c-9a14e2084b86',
    city: 'Edmonton',
    type: 'public',
    name: 'Eagle Rock Golf Course',
    address: '50549 - RR 234, Luduc County, AB, T4X 0L7',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '81da0d8f-0703-4521-959c-587db1c42ab0',
    city: 'Edmonton',
    type: 'public',
    name: 'Meadowview Golf & Country Club',
    address: '26329 Meadowview Dr, Sturgeon County, AB, T8T 0L7',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: 'd14af8c4-98a6-4699-93f9-9214d4c62a4f',
    city: 'Edmonton',
    type: 'private',
    name: 'Belvedere Golf & Country Club',
    address: '51418 Hwy 21, Sherwood Park, AB, T8H 2T2',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '83feb150-3065-4894-b00c-bb0ae88c48b7',
    city: 'Edmonton',
    type: 'public',
    name: 'The Broadmoor Golf Course',
    address: '2100 Oak St, Sherwood Park, AB, T8A 0V9',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '3383e230-8b67-4cd4-bd30-8160b60bf46a',
    city: 'Edmonton',
    type: 'public',
    name: 'Sturgeon Valley Golf & Country Club',
    address: '25114 Sturgeon Rd, Sturgeon County, AB, T8T 1S6',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '4dcf50a7-cdc6-4f48-b694-aa7bcbe78d13',
    city: 'Edmonton',
    type: 'public',
    name: 'Terrae Pines Golf & Country Club',
    address: 'Suite 403, 3-11 Bellerose Drive, St. Albert, AB, T8N 5C9',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'ff8d7b30-aec4-4bff-8791-137930eb3657',
    city: 'Edmonton',
    type: 'public',
    name: 'Coyote Crossing',
    address: '52321 Range Road 233, Sherwood Park, AB, T8B 1C8',
    holes: 9,
    drivingRange: true,
  },
  {
    uuid: 'cc41b169-776c-4534-bd30-ddd8cad6db3e',
    city: 'Edmonton',
    type: 'public',
    name: 'Northern Bear Golf Club',
    address: '51055 Range Road 222, Sherwood Park, AB, T8C 1G9',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '50b6ea62-98ce-42b3-8861-7de164fa817d',
    city: 'Edmonton',
    type: 'public',
    name: 'Country Side Golf Club',
    address: '51466 Range Road 232, Sherwood Park, AB, T8B 1L1',
    holes: 27,
    drivingRange: true,
  },
  {
    uuid: '24e48b1b-6ddd-4077-b6f8-071c9999353e',
    city: 'Edmonton',
    type: 'public',
    name: 'The Legends Golf & Country Club',
    address: '53541 Range Road 232, Sherwood Park, AB, T8A 4V2',
    holes: 27,
    drivingRange: false,
  },
  {
    uuid: '93bb8ea2-0e18-4f2c-898d-96ec23d1fad0',
    city: 'Edmonton',
    type: 'public',
    name: 'Coloniale Golf & Country Club',
    address: '10 Country Club Drive, Beaumont, AB, T4X 1M1',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '2f94235b-46c0-4be4-80f5-f57ff60982ce',
    city: 'Edmonton',
    type: 'public',
    name: 'Westridge Park Golf Course',
    address: 'Highway 60, Devon, AB, T0C 1E0',
    holes: 9,
    drivingRange: true,
  },
  {
    uuid: '5892175c-6cf9-4b68-b103-a412a3e26105',
    city: 'Edmonton',
    type: 'public',
    name: 'Devon Golf & Conference Centre',
    address: '1130 Rivervalley, Devon, AB, T9G 1Z3',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '3097744e-369f-481b-b63b-17c5870a5a92',
    city: 'Edmonton',
    type: 'public',
    name: 'The Links At Spruce Grove',
    address: '100 Links Rd, Spruce Grove, AB, T7X 3C9',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '157e36ee-16f0-43ed-953c-855f8efba5cd',
    city: 'Edmonton',
    type: 'public',
    name: 'Fox Run Golf Course',
    address: '22336 Township Road 540, Ardrossan, AB, T8E 2L7',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '124dd6b9-5fb2-4ebf-967c-52a67cf15241',
    city: 'Edmonton',
    type: 'private',
    name: 'Blackhawk Golf Club',
    address: '51111 Range Road 255, Spruce Grove, AB, T7Y 1A8',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '280b4b35-0e83-4fbc-8c6d-23ccc8556d3d',
    city: 'Edmonton',
    type: 'public',
    name: 'Edmonton Springs Golf Course',
    address: '53302 Range Rd 264 #9, Spruce Grove, AB, T7X 3H5',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '6ca10b6c-b438-4d11-b3a7-5ce0c48b1feb',
    city: 'Edmonton',
    type: 'public',
    name: 'Deer Meadows Golf Course & RV Park',
    address: '53303A Highway 44, Spruce Grove, AB, T7X 3H5',
    holes: 9,
    drivingRange: false,
  },
  {
    uuid: '9d12aa3c-bbe0-4677-adba-596020d50b19',
    city: 'Edmonton',
    type: 'public',
    name: 'The Ranch Golf & Country Club',
    address: '9574 Pinchbeck Road, Acheson, AB, T7X 6K8',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '167b6fe9-6045-4dd7-840b-9f7e0c82111d',
    city: 'Edmonton',
    type: 'public',
    name: 'Fort Saskatchewan Golf & Curling Club',
    address: '9420 102 St., Fort Saskatchewan, AB, T8L 1T8',
    holes: 9,
    drivingRange: false,
  },
  {
    uuid: '90d71ba1-a0ab-4d5a-a5a6-87f7f96efce6',
    city: 'Edmonton',
    type: 'public',
    name: 'Fort in View Golf Course',
    address: '55028 - RR 230, Sturgeon County, AB, T8L 5B4',
    holes: 27,
    drivingRange: true,
  },
  {
    uuid: 'bd488838-c6ab-4d3c-9850-3bd81a7ab492',
    city: 'Edmonton',
    type: 'public',
    name: 'Elk Island Golf Course',
    address: 'Elk Island National Park, Sherwood Park, AB, T0B 2R0',
    holes: 9,
    drivingRange: false,
  },
  {
    uuid: '367ffe8d-b063-41f8-ae14-abc1e1ce71fe',
    city: 'Edmonton',
    type: 'public',
    name: 'Leduc Golf Club',
    address: '5725 Black Gold Drive, Leduc, AB, T9E 8C4',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'eaa0044b-092c-478c-8a3a-40e4c8b1f4e9',
    city: 'Edmonton',
    type: 'public',
    name: 'RedTail Landing Golf Club',
    address: 'Edmonton International Airport, Nisku, AB, T9E 8A8',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '546618f5-bbfb-4e15-8146-081f5c3b4114',
    city: 'Edmonton',
    type: 'public',
    name: 'Cardiff Golf & Country Club',
    address: '55307 RR 251, Morinville, AB, T8R 1S1',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '6205e3f9-d3e6-4c46-bb88-bcfb94f95fa1',
    city: 'Edmonton',
    type: 'public',
    name: 'Spring Creek Golf Course',
    address: '24007 Twp Rd 560, Bon Accord, AB, T0A 0K0',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '6a518e5a-7a03-4c5a-a8fa-8ec48b116e20',
    city: 'Edmonton',
    type: 'public',
    name: 'Duffy\'s Challenge',
    address: '54007 Hwy 779, Stony Plain, AB, T7X 1Y4',
    holes: 18,
    drivingRange: false,
  },
  {
    uuid: '9e728f97-85cb-477f-9fc5-9593559a0db6',
    city: 'Edmonton',
    type: 'public',
    name: 'Stony Plain Golf Course',
    address: '18 Fairway Dr., Stony Plain, AB, T7Z 1M3',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '7634e526-ebe5-44ca-a64f-46d597bd7afc',
    city: 'Edmonton',
    type: 'public',
    name: 'Goose Hummock Golf Resort',
    address: '23210, Township Road 564, Gibbons, AB, T0A 1N0',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '77a7b4e3-2288-40b9-9532-4761e6ea70e7',
    city: 'Edmonton',
    type: 'public',
    name: 'Calahoo Hills Golf Course',
    address: '54410 Range Road 280, Sturgeon County, AB, T8R 1Z5',
    holes: 9,
    drivingRange: false,
  },
  {
    uuid: '07751c5e-587b-4e8a-b769-f0aaf96bf907',
    city: 'Edmonton',
    type: 'public',
    name: 'Bull Hill Golf & Driving Range',
    address: 'Joseph Lake Road, New Sarepta, AB, T0B 3M0',
    holes: 9,
    drivingRange: false,
  },
  {
    uuid: 'de82eb51-8ae3-4d3e-8681-b21be9352d32',
    city: 'Edmonton',
    type: 'public',
    name: 'Grouse Nest Golf Course',
    address: '53318 Range Road 31, Parkland County, AB, T7Y 0E3',
    holes: 9,
    drivingRange: false,
  },
  {
    uuid: '27f2ec33-c487-495f-9942-17d55f225b18',
    city: 'Calgary',
    type: 'unknown',
    name: 'Carnmoney Golf & Country Club',
    address: '44001 Dunbow Rd, De Winton, AB T1S 4X7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '66bca2bc-cabb-4fb5-b948-01b9d7b1e515',
    city: 'Calgary',
    type: 'private',
    name: 'Cottonwood Golf & Country Club',
    address: '88008 226 Ave E #200, Foothills, AB T1S 4A6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '5d2210a1-5c0f-4c7d-9e22-0e3f64eb7824',
    city: 'Banff',
    type: 'unknown',
    name: 'Fairmont Banff Springs Golf Course',
    address: '405 Spray Avenue, Banff, AB T1L 1J4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '8f7e9d6c-3a2b-4e1f-9f8a-5b4c3d2a1e0f',
    city: 'Edmonton',
    type: 'unknown',
    name: 'Lone Spruce Driving Range',
    address: '25522 Secondary Hwy, 633 Villeneuve Rd, St. Albert, AB T8N 3W8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '3f7b8c9d-1a2e-4f5g-6h7i-8j9k0l1m2n3o',
    city: 'Calgary',
    type: 'unknown',
    name: 'McKenzie Meadows Golf Club',
    address: '17215 McKenzie Meadows Dr SE, Calgary, AB T2Z 2T9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '8f9e0d7c-6b5a-4c3d-2e1f-0a9b8c7d6e5f',
    city: 'Ponoka',
    type: 'unknown',
    name: 'Ponoka Golf Club',
    address: '3519 46 St, Ponoka, AB T4J 1R5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd251317a-60e4-4542-b371-973ab25c462c',
    city: 'Sechelt, BC',
    type: 'unknown',
    name: 'Blue Ocean Golf Club',
    address: '6177 Ripple Way, Sechelt, BC V7Z 0R2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '5f7e6d4c-3b2a-1e9d-8c7f-0a6b5d4e3f2g',
    city: 'Radium Hot Springs',
    type: 'unknown',
    name: 'Springs Course – Radium Golf Group',
    address: '4714 Springs Dr #310, Radium Hot Springs BC V0A 1M0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '7f9c1d3e-5b2a-4f8d-9e6c-3a1b2d4f5e7g',
    city: 'Edmonton',
    type: 'indoor',
    name: 'The Golf Den (Indoor)',
    address: '975 Ordze Rd, Sherwood Park AB T8A 4L7',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'a8b7c6d5-e4f3-4a2b-8c9d-1e2f3a4b5c6d',
    city: 'Edmonton',
    type: 'indoor',
    name: 'Gimme Virtual Golf (Indoor)',
    address: '10846 170 St NW, Edmonton, AB, T5S 2H7',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'd1e2f3a4-b5c6-4d7e-8f9g-0h1i2j3k4l5m',
    city: 'Edmonton',
    type: 'indoor',
    name: 'The Golf Factory (Indoor)',
    address: '10457 184 St NW Edmonton, Alberta T5S 1G1',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '1a2b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p',
    city: 'Calgary',
    type: 'private',
    name: 'Willow Park Golf & Country Club',
    address: '639 Willow Park Dr SE, Calgary, AB T2J 0L6',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '3e4f5g6h-7i8j-9k0l-1m2n-3o4p5q6r7s8t',
    city: 'Edmonton',
    type: 'indoor',
    name: 'B.E FIT Space (Indoor)',
    address: '6031 Gateway Blvd NW, Edmonton AB T6H 2H3',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '9a8b7c6d-5e4f-3g2h-1i0j-9k8l7m6n5o4p',
    city: 'Edmonton',
    type: 'indoor',
    name: 'GOLF360 (Indoor)',
    address: '6031 Andrews Way SW, Edmonton, AB',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'f1e2d3c4-b5a6-4789-9876-543210fedcba',
    city: 'Calgary',
    type: 'indoor',
    name: 'Golf Town - Riocan Beacon Hill (Indoor)',
    address: '11450 Sarcee Trail NW, Calgary, AB T3R 0A1',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'a1b2c3d4-e5f6-4789-9876-123456789abc',
    city: 'Calgary',
    type: 'indoor',
    name: 'Golf Town - Sunridge Way (Indoor)',
    address: '500, 2929 Sunridge Way NE Unit 200, Calgary, AB T1Y 7K7',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'b2c3d4e5-f6g7-4789-9876-987654321def',
    city: 'Calgary',
    type: 'indoor',
    name: 'Golf Town - Shawville Blvd (Indoor)',
    address: '47 Shawville Blvd SE, Calgary, AB T2Y 3P3',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '2d3e4f5g-6h7i-8j9k-1l2m-3n4o5p6q7r8s',
    city: 'Edmonton',
    type: 'indoor',
    name: 'Paradise Golf (Indoor)',
    address: '6109 45 St #1, Leduc, AB T9E 7C3',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '7d8e9f0a-1b2c-3d4e-5f6g-7h8i9j0k1l2m',
    city: 'Edmonton',
    type: 'indoor',
    name: 'Aurora Golf + Bar Beaumont (Indoor)',
    address: '5015 52 Ave, Beaumont, AB T4X 1E5',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '8e9f0a1b-2c3d-4e5f-6g7h-8i9j0k1l2m3n',
    city: 'Olds',
    type: 'indoor',
    name: 'Aurora Golf + Bar Olds (Indoor)',
    address: '4513 52 Ave #16b, Olds, AB T4H 1M8',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'f9e8d7c6-b5a4-4321-9876-543210abcdef',
    city: 'Calgary',
    type: 'indoor',
    name: 'Bryce Halverson Teaching Studio (Indoor)',
    address: '8217 31 St SE, Calgary, AB',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'c4d3b2a1-9876-5432-1098-7654321fedcb',
    city: 'Calgary',
    type: 'public',
    name: 'The Track Golf Course',
    address: '333 Boulder Creek Dr, Langdon, AB T0J 1X3',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '8f4e7d2c-1a9b-4c5d-8e3f-2b1a9c8d7e6f',
    city: 'Edmonton',
    type: 'public',
    name: 'Cattail Crossing Golf Club',
    address: '24427 Township Road 542, Edmonton AB, T8T 1L4',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: '3a2b1c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p',
    city: 'Edmonton',
    type: 'public',
    name: 'Canada Golf Card Driving Range',
    address: '13510 Ellerslie Rd SW, Edmonton AB T6W 0B3',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'e7d6c5b4-a3f2-4e1d-9b8c-7d6e5f4a3b2c',
    city: 'Canmore',
    type: 'private',
    name: 'Stewart Creek Golf & Country Club',
    address: '4100 Stewart Creek Drive, Canmore AB T1W 2V3',
    holes: 0,
    drivingRange: 'true',
  },
  {
    uuid: 'a1b2c3d4-5e6f-7g8h-9i0j-1k2l3m4n5o6p',
    city: 'Canmore',
    type: 'unknown',
    name: 'Silvertip Resort',
    address: '2000 Silvertip Trail, Canmore, AB T1W 3J4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b2c3d4e5-6f7g-8h9i-0j1k-2l3m4n5o6p7q',
    city: 'Canmore',
    type: 'unknown',
    name: 'Canmore Golf & Curling Club',
    address: 'Pro Shop, 2000 8 Ave, Canmore, AB T1W 1Y2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '9d847e3a-1b2c-4d5e-8f9a-0b1c2d3e4f5g',
    city: 'Calgary',
    type: 'unknown',
    name: 'Sirocco Golf Club',
    address: '210178 64 St W, Calgary AB T1S 5G5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f1e9d8c7-b6a5-4321-9876-543210fedcba',
    city: 'Innisfail',
    type: 'unknown',
    name: 'Innisfail Golf Club',
    address: '6080 Lakewood Dr, Innisfail, AB T4G 1S7',
    holes: 18,
    drivingRange: 'unknown',
  },
  {
    uuid: '2a1b3c4d-5e6f-7g8h-9i0j-1k2l3m4n5o6p',
    city: 'Medicine Hat',
    type: 'indoor',
    name: 'Studio Fore (Indoor)',
    address: '753 6th St. S.E., Medicine Hat, AB',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'b4a3c2d1-e5f6-4789-9876-123456789def',
    city: 'Victoria',
    type: 'unknown',
    name: 'Uplands Golf Club',
    address: '3300 Cadboro Bay Rd, Victoria BC V8R 5K5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a1b2c3d4-e5f6-4789-9876-456789abcdef',
    city: 'Victoria',
    type: 'indoor',
    name: 'Iron & Wood Golf Simulators (Indoor)',
    address: '3453 Saanich Rd, VICTORIA BRITISH COLUMBIA V8X 1W6',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'c5d4e3f2-1234-5678-9abc-def012345678',
    city: 'Victoria',
    type: 'unknown',
    name: 'Highland Pacific Golf',
    address: '450 Creed Rd, Victoria BC V9B 6C9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e2d1c0b9-8a7f-6543-2109-876543210abc',
    city: 'Chilliwack',
    type: 'unknown',
    name: 'Cheam Mountain Golf Course',
    address: '44610 Luckakuck Way, Chilliwack BC V2R 4A7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f3e2d1c0-b9a8-7654-3210-987654321def',
    city: 'Duncan',
    type: 'public',
    name: 'Duncan Meadows Golf Course',
    address: '6507 N Rd, Duncan, BC V9L 5Z2',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'g4f3e2d1-c0b9-8765-4321-098765432ghi',
    city: 'Duncan',
    type: 'indoor',
    name: 'The Tee Box - Cowichan Valley Golf Simulators (Indoor)',
    address: '5869 York Rd, Duncan, BC V9L 3S3',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'g5f4e3d2-c1b0-9876-5432-109876543ijk',
    city: 'Vancouver',
    type: 'public',
    name: 'Tsawwassen Springs',
    address: '5133 Springs Blvd, Tsawwassen, BC V4M 0A6',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'i7h6g5f4-e3d2-c1b0-a9f8-87654321abcd',
    city: 'Surrey',
    type: 'private',
    name: 'Northview Golf & Country Club',
    address: '6857 168 St, Surrey, BC V3S 3T6',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'h6g5f4e3-d2c1-b0a9-8765-432109876lmn',
    city: 'Online',
    type: 'online',
    name: 'Online Lesson',
    address: 'Virtual Location',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'd7e8f9a0-b1c2-4d3e-5f6g-7h8i9j0k1l2m',
    city: 'Medicine Hat',
    type: 'unknown',
    name: 'Desert Blume Golf Club',
    address: '107 Clubhouse Dr. SW Medicine Hat, AB T1B 0A4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e1f2d3c4-b5a6-4c7d-8e9f-0a1b2c3d4e5f',
    city: 'Edmonton',
    type: 'public',
    name: 'Big Moose Driving Range',
    address: '13415 41 Ave SW, Edmonton, AB T6W 1A7',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'f1e2d3c4-b5a6-7c8d-9e0f-1a2b3c4d5e6f',
    city: 'Mountain View County',
    type: 'unknown',
    name: 'Olds Golf Club',
    address: '33042 Range Rd 12, Mountain View County, AB T4H 4N3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'h7i8j9k0-l1m2-n3o4-p5q6-r7s8t9u0v1w2',
    city: 'Richmond Hill',
    type: 'unknown',
    name: 'Summit Golf & Country Club',
    address: '11901 Yonge St, Richmond Hill, ON L4E 3N9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b8c7d9e5-a4f3-4e2d-9c1b-5a4b3c2d1e0f',
    city: 'Regina',
    type: 'unknown',
    name: 'Deer Valley Golf Club',
    address: '10 Deer Valley Rd, Deer Valley, SK S2V 1B6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c9d8e7f6-a5b4-4c3d-8e2f-1a9b8c7d6e5f',
    city: 'Toronto',
    type: 'public',
    name: 'Centennial Park Golf Centre - Etobicoke',
    address: '550 Centennial Park Blvd, Etobicoke, ON M9C 5R5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd0e9f8a7-b6c5-4d4e-9f3a-2b0c9d8e7f6a',
    city: 'Toronto',
    type: 'indoor',
    name: 'Master Golf - Etobicoke (Indoor)',
    address: '289 Horner Ave Suite C, Etobicoke, ON M8Z 0A9',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'e1f0a9b8-c7d6-4e5f-0a4b-3c1d0e9f8a7b',
    city: 'Saskatoon',
    type: 'private',
    name: 'Moon Lake Golf and Country Club',
    address: '905 Valley Rd, Saskatoon, SK S7K 3J6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a2b3c4d5-e6f7-8901-2345-6789abcdef01',
    city: 'Edmonton',
    type: 'public',
    name: 'South Century Driving Range',
    address: '121 Century Road S. Spruce Grove, AB T7X 3X7',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'b3c4d5e6-f7a8-9012-3456-789abcdef012',
    city: 'Edmonton',
    type: 'public',
    name: 'Pineridge Golf Resort',
    address: '53213 Hwy 31 Seba Beach, AB T0E 2B0',
    holes: 18,
    drivingRange: true,
  },
  {
    uuid: 'c4d5e6f7-a8b9-0123-4567-89abcdef0123',
    city: 'Edmonton',
    type: 'indoor',
    name: 'Golf Biz Canada Virtual Golf (Indoor)',
    address: '101 N Park Dr, Stony Plain, AB T7Z 0J5',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '2b4c6d8e-0f3a-5179-bdf2-345678901bcd',
    city: 'Radium Hot Springs',
    type: 'unknown',
    name: 'Radium Course – Radium Golf Group',
    address: '8100 Golf Course Rd, Radium Hot Springs, BC V0A 1M0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '3c5d7e9f-1a4b-628a-cef3-456789012cde',
    city: 'Invermere',
    type: 'unknown',
    name: 'Eagle Ranch',
    address: '9581 Eagle Rnch Trl, Invermere, BC V0A 1K0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '4d6e8f0a-2b5c-739b-def4-567890123def',
    city: 'Invermere',
    type: 'unknown',
    name: 'Copper Point Golf Club',
    address: '#651, Hwy 93/95, RR#3, Invermere, BC V0A 1K3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '5e7f9a1b-3c6d-84ac-ef05-678901234ef0',
    city: 'Windermere',
    type: 'unknown',
    name: 'Windermere Valley Golf Course',
    address: '1881 Windermere Loop Rd, Windermere, BC V0B 2L2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '6f8a0b2c-4d7e-95bd-f016-789012345f01',
    city: 'Fairmont Hot Springs',
    type: 'unknown',
    name: 'Creekside Golf Course',
    address: '5083 Hot Springs Rd, Fairmont Hot Springs, BC V0A 1K4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '7a9b1c3d-5e8f-a6ce-0127-890123456012',
    city: 'Fairmont Hot Springs',
    type: 'unknown',
    name: 'Mountainside Golf Course',
    address: '5083 Hot Springs Rd, Fairmont Hot Springs, BC V0A 1K4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '8b0c2d4e-6f9a-b7df-1238-901234567123',
    city: 'Fairmont Hot Springs',
    type: 'unknown',
    name: 'Riverside Golf Course',
    address: '5097 Riverview Rd, Fairmont Hot Springs, BC V0A 1K4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '9c1d3e5f-7a0b-c8e0-2349-012345678234',
    city: 'Kimberley',
    type: 'unknown',
    name: 'Bootleg Gap',
    address: '400 315 Ave, Kimberley, BC V1A 3G9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '0d2e4f6a-8b1c-d9f1-345a-123456789345',
    city: 'Kimberley',
    type: 'unknown',
    name: 'Trickle Creek Golf Course',
    address: '500 Gerry Sorensen Way, Kimberley, BC V1A 2Y5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '1e3f5a7b-9c2d-ea02-456b-234567890456',
    city: 'Kimberley',
    type: 'unknown',
    name: 'Purcell Golf',
    address: '415 302 Ave, Kimberley, BC V1A 3G5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '2f4a6b8c-0d3e-fb13-567c-345678901567',
    city: 'Cranbrook',
    type: 'unknown',
    name: 'Shadow Mountain Golf Course',
    address: '7145 BC-95A, Cranbrook, BC V1C 7B6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '3a5b7c9d-1e4f-0c24-678d-456789012678',
    city: 'Cranbrook',
    type: 'unknown',
    name: 'St Eugene Golf Course',
    address: '7777 Mission Road, Cranbrook, BC V1C 7E5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '4b6c8d0e-2f5a-1d35-789e-567890123789',
    city: 'Cranbrook',
    type: 'unknown',
    name: 'Mission Hills Golf Course',
    address: '3320 Theatre Rd, Cranbrook, BC V1C 7B8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '5c7d9e1f-3a6b-2e46-890f-678901234890',
    city: 'Cranbrook',
    type: 'unknown',
    name: 'Cranbrook Golf Club',
    address: '2700 2 St S, Cranbrook, BC V1C 4N8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '6d8e0f2a-4b7c-3f57-901a-789012345901',
    city: 'Cranbrook',
    type: 'unknown',
    name: 'Wildstone Golf Course',
    address: '950 Wildstone Dr, Cranbrook, BC V1C 0B4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '7e9f1a3b-5c8d-4068-012b-890123456012',
    city: 'Fernie',
    type: 'unknown',
    name: 'Fernie Golf Club',
    address: '201 Fairway Dr, Fernie, BC V0B 1T2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '8f0a2b4c-6d9e-5179-123c-901234567123',
    city: 'Sparwood',
    type: 'unknown',
    name: 'Sparwood Golf Club',
    address: '2002 BC-3, Sparwood, BC V0B 2G1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '9a1b3c5d-7e0f-628a-234d-012345678234',
    city: 'Blairmore',
    type: 'unknown',
    name: 'Crowsnest Pass Golf Club',
    address: '90 Golf Course Road, Blairmore, AB T0K 0E0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '0b2c4d6e-8f1a-739b-345e-123456789345',
    city: 'Claresholm',
    type: 'unknown',
    name: 'The Bridges at Claresholm Golf Course',
    address: '349 39 Ave W, Claresholm, AB T0L 0T0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '1c3d5e7f-9a2b-84ac-456f-234567890456',
    city: 'Nanton',
    type: 'unknown',
    name: 'Nanton Golf Club',
    address: 'Highway 533 East, Nanton, AB T0L 1R0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '2d4e6f8a-0b3c-95bd-567a-345678901567',
    city: 'High River',
    type: 'unknown',
    name: 'Highwood Golf Club',
    address: '400 7 St NW, High River, AB T1V 1M6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '3e5f7a9b-1c4d-a6ce-678b-456789012678',
    city: 'Okotoks',
    type: 'unknown',
    name: 'River\'s Edge Golf Club',
    address: '370137 64 St E, Okotoks, AB T1S 1A5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '4f6a8b9c-2d5e-a7f8-bcd3-efg456789abc',
    city: 'Golden',
    type: 'unknown',
    name: 'Golden Golf Club',
    address: '576 Golf Course Dr, Golden, BC V0A 1H0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '5a7b9c0d-3e6f-b8g9-cde4-fgh567890bcd',
    city: 'Revelstoke',
    type: 'unknown',
    name: 'Revelstoke Golf Club',
    address: '171 Columbia Park Dr, Revelstoke, BC V0E 2S0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '6b8c0d1e-4f7g-c9h0-def5-ghi678901cde',
    city: 'Kelowna',
    type: 'unknown',
    name: 'Black Mountain Golf Club',
    address: '575 Black Mountain Dr, Kelowna, BC V1P 1P7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '7c9d1e2f-5g8h-d0i1-efg6-hij789012def',
    city: 'Kelowna',
    type: 'unknown',
    name: 'Gallagher\'s Canyon Golf Club',
    address: '4320 Gallaghers Dr W, Kelowna, BC V1W 3Z8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '8d0e2f3g-6h9i-e1j2-fgh7-ijk890123efg',
    city: 'Kelowna',
    type: 'indoor',
    name: 'Golf Evolution Kelowna',
    address: '2544 Enterprise Way, Kelowna, BC V1X 7X5',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '9e1f3g4h-7i0j-f2k3-ghi8-jkl901234fgh',
    city: 'Kelowna',
    type: 'unknown',
    name: 'The Harvest Golf Club',
    address: '2725 K. L. O. Rd, Kelowna, BC V1W 4S1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '0f2g4h5i-8j1k-g3l4-hij9-klm012345ghi',
    city: 'Kelowna',
    type: 'public',
    name: 'Kelowna Driving Range & Mini Golf',
    address: '3810 Casorso Rd, Kelowna, BC V1W 4M7',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '1g3h5i6j-9k2l-h4m5-ijk0-lmn123456hij',
    city: 'Kelowna',
    type: 'unknown',
    name: 'Kelowna Golf & Country Club',
    address: '1297 Glenmore Dr, Kelowna, BC V1Y 4P4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '2h4i6j7k-0l3m-i5n6-jkl1-mno234567ijk',
    city: 'Kelowna',
    type: 'unknown',
    name: 'Shadow Ridge Golf Club',
    address: '3770 Bulman Rd, Kelowna, BC V1X 7V1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '3i5j7k8l-1m4n-j6o7-klm2-nop345678jkl',
    city: 'Kelowna',
    type: 'public',
    name: 'The Golf Centre Kelowna Driving Range',
    address: '2650 Benvoulin Rd, Kelowna, BC V1W 2E1',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: '4j6k8l9m-2n5o-k7p8-lmn3-opq456789klm',
    city: 'Kelowna',
    type: 'unknown',
    name: 'Tower Ranch Golf & Country Club',
    address: '1855 Tower Ranch Blvd, Kelowna, BC V1P 1R2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '5k7l9m0n-3o6p-l8q9-mno4-pqr567890lmn',
    city: 'Kelowna',
    type: 'unknown',
    name: 'Sunset Ranch Golf & Country Club',
    address: '5101 Upper Booth Rd S, Kelowna, BC V1X 7V8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '6l8m0n1o-4p7q-m9r0-nop5-qrs678901mno',
    city: 'West Kelowna',
    type: 'unknown',
    name: 'Two Eagles Golf Course & Academy',
    address: '3509 Carrington Rd, West Kelowna, BC V4T 2E6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '7m9n1o2p-5q8r-n0s1-opq6-rst789012nop',
    city: 'Canoe',
    type: 'unknown',
    name: 'Club Shuswap Golf Resort',
    address: '5751 Trans-Canada Hwy, Canoe, BC V0E 1K0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '8n0o2p3q-6r9s-o1t2-pqr7-stu890123opq',
    city: 'Vernon',
    type: 'unknown',
    name: 'Hillview Golf Course',
    address: '1101 14th Ave, Vernon, BC V1B 2S5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '9o1p3q4r-7s0t-p2u3-qrs8-tuv901234pqr',
    city: 'Vernon',
    type: 'unknown',
    name: 'Predator Ridge Resort',
    address: '301 Village Centre Pl, Vernon, BC V1H 1T2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '0p2q4r5s-8t1u-q3v4-rst9-uvw012345qrs',
    city: 'Salmon Arm',
    type: 'unknown',
    name: 'Salmon Arm Golf Club',
    address: '3641 BC-97B, Salmon Arm, BC V1E 3P8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '1q3r5s6t-9u2v-r4w5-stu0-vwx123456rst',
    city: 'Salmon Arm',
    type: 'unknown',
    name: 'Shuswap National',
    address: '6015 Shaw Rd, Salmon Arm, BC V1E 2W2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '2r4s6t7u-0v3w-s5x6-tuv1-wxy234567stu',
    city: 'Sicamous',
    type: 'unknown',
    name: 'MaraHills Golf Resort',
    address: '9851 Old Spallumcheen Rd, Sicamous, BC V0E 2V3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '3s5t7u8v-1w4x-t6y7-uvw2-xyz345678tuv',
    city: 'Spallumcheen',
    type: 'unknown',
    name: 'Spallumcheen Golf & Country Club',
    address: '9401 BC-97, Spallumcheen, BC V1H 1W9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '4t6u8v9w-2x5y-u7z8-vwx3-yza456789uvw',
    city: 'Vernon',
    type: 'unknown',
    name: 'The Rise Resort',
    address: '8800 Rising View Wy, Vernon, BC V1H 1Z9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '5u7v9w0x-3y6z-v8a9-wxy4-zab567890vwx',
    city: 'Vernon',
    type: 'unknown',
    name: 'Vernon Golf & Country Club',
    address: '800 Kalamalka Lake Rd, Vernon, BC V1T 6V2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '6v8w0x1y-4z7a-w9b0-xyz5-abc678901wxy',
    city: 'Kananaskis Village',
    type: 'unknown',
    name: 'Kananaskis Country Golf Course',
    address: '1 Lorette Rd, Kananaskis Village, AB T0L 2H0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '7w9x1y2z-5a8b-x0c1-yza6-bcd789012xyz',
    city: 'Calgary',
    type: 'unknown',
    name: 'Lynx Ridge Golf Club',
    address: '8 Lynx Ridge Blvd, Calgary, AB T3L 2M3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: '8x0y2z3a-6b9c-y1d2-zab7-cde890123yza',
    city: 'Okotoks',
    type: 'unknown',
    name: 'D\'Arcy Ranch Golf Club',
    address: '376 D\'arcy Ranch Dr, Okotoks, AB T1S 5T5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a9b8c7d6-e5f4-4321-9876-ba9876543210',
    city: 'Calgary',
    type: 'unknown',
    name: 'Banff Springs GC',
    address: 'Golf Course Rd, Banff, AB T1L 1J4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b0c9d8e7-f6a5-4321-9876-cb0987654321',
    city: 'Calgary',
    type: 'unknown',
    name: 'Bearspaw GC',
    address: '61 Hamilton Dr, Calgary, AB T3R 1A2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c1d0e9f8-a7b6-4321-9876-dc1098765432',
    city: 'Calgary',
    type: 'unknown',
    name: 'Calgary G&CC',
    address: '919 50 Ave SW, Calgary, AB T2S 1H1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd2e1f0a9-b8c7-4321-9876-ed2109876543',
    city: 'Calgary',
    type: 'unknown',
    name: 'Canyon Meadows G&CC',
    address: '12501 14 St SW, Calgary, AB T2W 2Y8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e3f2a1b0-c9d8-4321-9876-fe3210987654',
    city: 'Calgary',
    type: 'unknown',
    name: 'Country Hills GC',
    address: '1334 Country Hills Blvd NW, Calgary, AB T3K 5A9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f4a3b2c1-d0e9-4321-9876-af4321098765',
    city: 'Calgary',
    type: 'unknown',
    name: 'Earl Grey GC',
    address: '6540 20 St SW, Calgary, AB T3E 5L2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a5b4c3d2-e1f0-4321-9876-ba5432109876',
    city: 'Calgary',
    type: 'unknown',
    name: 'Elbow Springs GC',
    address: '240086 Lott Creek Dr, Calgary, AB T3Z 2V4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b6c5d4e3-f2a1-4321-9876-cb6543210987',
    city: 'Calgary',
    type: 'unknown',
    name: 'HeatherGlen GC',
    address: '234024 Range Rd 285, Rocky View, AB T1X 0J8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c7d6e5f4-a3b2-4321-9876-dc7654321098',
    city: 'Calgary',
    type: 'unknown',
    name: 'Heritage Pointe GC',
    address: '1 Heritage Pointe Dr, De Winton, AB T1S 4H1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd8e7f6a5-b4c3-4321-9876-ed8765432109',
    city: 'Calgary',
    type: 'unknown',
    name: 'Inglewood G&CC',
    address: '19 Gosling Way SE, Calgary, AB T2B 3V7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e9f8a7b6-c5d4-4321-9876-fe9876543210',
    city: 'Calgary',
    type: 'unknown',
    name: 'Mickelson National GC',
    address: '34122 East Harmony Trl, Calgary, AB T3Z 0G8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f0a9b8c7-d6e5-4321-9876-af0987654321',
    city: 'Calgary',
    type: 'unknown',
    name: 'Pinebrook G&CC',
    address: '166 Pinebrook Way SW, Calgary, AB T3Z 3K3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a1b0c9d8-e7f6-4321-9876-ba1098765432',
    city: 'Calgary',
    type: 'unknown',
    name: 'Priddis Greens G&CC',
    address: '1 Priddis Greens Dr, Foothills County, AB T0L 1W3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b2c1d0e9-f8a7-4321-9876-cb2109876543',
    city: 'Calgary',
    type: 'unknown',
    name: 'Redwood Meadows G&CC',
    address: '100 – #1 Tsuut\'ina Dr, Redwood Meadows, AB T3Z 3G3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c3d2e1f0-a9b8-4321-9876-dc3210987654',
    city: 'Calgary',
    type: 'unknown',
    name: 'Serenity GC',
    address: '222111 Range Rd 274, Rocky View County, AB T0J 0V0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd4e3f2a1-b0c9-4321-9876-ed4321098765',
    city: 'Calgary',
    type: 'unknown',
    name: 'Speargrass GC',
    address: '82 Speargrass Blvd, Carseland, AB T0J 0M0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e5f4a3b2-c1d0-4321-9876-fe5432109876',
    city: 'Calgary',
    type: 'unknown',
    name: 'Springbank Links GC',
    address: '125 Hackamore Trl, Calgary, AB T3Z 1C2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f6a5b4c3-d2e1-4321-9876-af6543210987',
    city: 'Calgary',
    type: 'unknown',
    name: 'The Links of GlenEagles',
    address: '100 Gleneagles Dr, Cochrane, AB T4C 1P5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a7b6c5d4-e3f2-4321-9876-ba7654321098',
    city: 'Calgary',
    type: 'unknown',
    name: 'Turner Valley GC',
    address: '700 Imperial Dr SE, Diamond Valley, AB T0L 2A0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b8c7d6e5-f4a3-4321-9876-cb8765432109',
    city: 'Calgary',
    type: 'unknown',
    name: 'Valley Ridge GC',
    address: '11618 Valley Ridge Park NW, Calgary, AB T3B 5L4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c9d8e7f6-a5b4-4321-9876-dc9876543210',
    city: 'Calgary',
    type: 'unknown',
    name: 'Wingfield GC',
    address: '3434 48 Ave NE, Calgary, AB T3J 0L1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd0e9f8a7-b6c5-4321-9876-ed0987654321',
    city: 'Calgary',
    type: 'unknown',
    name: 'Winston GC (The)',
    address: '2502 6 St NE, Calgary, AB T2E 3Z3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e1f0a9b8-c7d6-4321-9876-fe1098765432',
    city: 'Calgary',
    type: 'unknown',
    name: 'Wintergreen G&CC',
    address: 'PO Bag #2, Bragg Creek, AB T0L 0K0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f2a1b0c9-d8e7-4321-9876-af2109876543',
    city: 'Calgary',
    type: 'unknown',
    name: 'Fox Hollow GC',
    address: '999 32 Ave NE, Calgary, AB T2E 6X6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a3b2c1d0-e9f8-5432-1098-ba3210987654',
    city: 'Edmonton',
    type: 'unknown',
    name: 'Rundle Park GC',
    address: '2902 118 Ave NW, Edmonton, AB',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b4c3d2e1-f0a9-5432-1098-cb4321098765',
    city: 'Edmonton',
    type: 'unknown',
    name: 'Riverside GC',
    address: '8630 Rowland Rd NW, Edmonton, AB T5J 2T6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c5d4e3f2-a1b0-5432-1098-dc5432109876',
    city: 'Edmonton',
    type: 'unknown',
    name: 'River Ridge G&CC',
    address: '5685 Windermere Blvd, Edmonton, AB T6W 0S6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd6e5f4a3-b2c1-5432-1098-ed6543210987',
    city: 'Edmonton',
    type: 'unknown',
    name: 'Fort Saskatchewan G&CC',
    address: '9312 102 St, Fort Saskatchewan, AB T8L 2C1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e7f6a5b4-c3d2-5432-1098-fe7654321098',
    city: 'Edmonton',
    type: 'unknown',
    name: 'Eagle Rock GC',
    address: '50549 Range Rd 234, Leduc County, AB T4X 0L7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f8a7b6c5-d4e3-5432-1098-af8765432109',
    city: 'Edmonton',
    type: 'unknown',
    name: 'Leduc GC',
    address: '5725 Black Gold Dr, Leduc, AB',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c8d7e6f5-a4b3-4c2d-9e1f-0a1b2c3d4e5f',
    city: 'Edmonton',
    type: 'indoor',
    name: 'Tap Golf (Indoor)',
    address: '4930 94b Ave NW, Edmonton, AB T6B 1G8',
    holes: 0,
    drivingRange: true,
  },
  {
    uuid: 'a9b8c7d6-e5f4-6543-2109-ba9876543210',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'River Bend G&RA',
    address: '3800 River Bend Dr, Red Deer, AB T4P 0Y4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b0c9d8e7-f6a5-6543-2109-cb0987654321',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Red Deer G&CC',
    address: '939 45 Ave, Red Deer, AB T4N 3M4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c1d0e9f8-a7b6-6543-2109-dc1098765432',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Olds GC',
    address: '5116 46 Ave, Olds, AB T4H 1G2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e3f2a1b0-c9d8-6543-2109-fe3210987654',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Wolf Creek GR',
    address: '6005 Highway 2A, Ponoka, AB T4J 1J2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f4a3b2c1-d0e9-6543-2109-af4321098765',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Gull Lake GC',
    address: 'Box 417, Rimbey, AB T0C 2J0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a5b4c3d2-e1f0-6543-2109-ba5432109876',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Pheasantback GC',
    address: 'Box 5390, Stettler, AB T0C 2L0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b6c5d4e3-f2a1-6543-2109-cb6543210987',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Pine Hills GC',
    address: 'Box 3897, Rocky Mountain House, AB T4T 1A2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c7d6e5f4-a3b2-6543-2109-dc7654321098',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Sundre GC',
    address: 'Box 1366, Sundre, AB T0M 1X0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd8e7f6a5-b4c3-6543-2109-ed8765432109',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Whispering Pines G&CC',
    address: '25054 South Pine Lake Rd, Pine Lake, AB T0M 1S0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e9f8a7b6-c5d4-6543-2109-fe9876543210',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Carstairs GC',
    address: 'Box 1408, Carstairs, AB T0M 0N0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f0a9b8c7-d6e5-6543-2109-af0987654321',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Collicutt Siding GC',
    address: 'Box 920, Crossfield, AB T0M 0S0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a1b0c9d8-e7f6-6543-2109-ba1098765432',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Coal Creek GR',
    address: 'Box 117, Ryley, AB T0B 4A0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b2c1d0e9-f8a7-6543-2109-cb2109876543',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Lakewood GR',
    address: 'Box 729, Sylvan Lake, AB T4S 1A6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c3d2e1f0-a9b8-6543-2109-dc3210987654',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Meadowlands GC',
    address: 'Box 4616, Sylvan Lake, AB T4S 1S8',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd4e3f2a1-b0c9-6543-2109-ed4321098765',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Lacombe G&CC',
    address: 'Box 4845, Lacombe, AB T4L 1N4',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e5f4a3b2-c1d0-6543-2109-fe5432109876',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Apple Creek GC',
    address: '717080 Range Rd 263, Rocky View County, AB T4B 4K3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f6a5b4c3-d2e1-6543-2109-af6543210987',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Water Valley GC',
    address: 'Box 249, Water Valley, AB T0M 2E0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a7b6c5d4-e3f2-6543-2109-ba7654321098',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'The Canal at Delacour GC',
    address: 'Box 23, Site 5, RR1, Delacour, AB T0M 0T0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b8c7d6e5-f4a3-6543-2109-cb8765432109',
    city: 'Central Alberta',
    type: 'unknown',
    name: 'Hanna G&CC',
    address: '501 3rd St W, Hanna, AB T0J 1P0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c9d8e7f6-a5b4-7654-3210-dc9876543210',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Barrhead GC',
    address: 'Box 6171, Barrhead, AB T7N 1A6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd0e9f8a7-b6c5-7654-3210-ed0987654321',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Whitecourt G&CC',
    address: 'Box 1864, Whitecourt, AB T7S 1P6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e1f0a9b8-c7d6-7654-3210-fe1098765432',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Westlock GC',
    address: '9537 Highway 44, Westlock, AB T7P 2P7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f2a1b0c9-d8e7-7654-3210-af2109876543',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Bonnyville G&CC',
    address: 'Box 5505, Bonnyville, AB T9N 2G3',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a3b2c1d0-e9f8-7654-3210-ba3210987654',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Lac La Biche G&CC',
    address: 'Box 389, Lac La Biche, AB T0A 2C0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b4c3d2e1-f0a9-7654-3210-cb4321098765',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Gilwood G&CC',
    address: 'Box 129, Slave Lake, AB T0G 2A0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c5d4e3f2-a1b0-7654-3210-dc5432109876',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Grande Prairie G&CC',
    address: '711040 Resources Rd, Grande Prairie, AB T8V 3A7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd6e5f4a3-b2c1-7654-3210-ed6543210987',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'The Dunes Golf and Winter Club',
    address: '60042 TWP Rd 704A, Grande Prairie, AB T8W 5K2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e7f6a5b4-c3d2-7654-3210-fe7654321098',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Fort McMurray GC',
    address: '100 Real Martin Dr, Fort McMurray, AB T9K 0B9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f8a7b6c5-d4e3-7654-3210-af8765432109',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Miskanaw GC',
    address: '1 MacDonald Dr, Fort McMurray, AB T9H 5C5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a9b8c7d6-e5f4-7654-3210-ba9876543210',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Hinton GC',
    address: '760 Keil Dr, Hinton, AB T7V 2C5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b0c9d8e7-f6a5-7654-3210-cb0987654321',
    city: 'Northern Alberta',
    type: 'unknown',
    name: 'Athabasca GC',
    address: 'Box 1305, Athabasca, AB T9S 2A9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c1d0e9f8-a7b6-8765-4321-dc1098765432',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Lethbridge CC',
    address: '101 Country Club Rd S, Lethbridge, AB T1J 4S5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd2e1f0a9-b8c7-8765-4321-ed2109876543',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Henderson Lake GC',
    address: '2727 South Parkside Dr S, Lethbridge, AB T1K 0C6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e3f2a1b0-c9d8-8765-4321-fe3210987654',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Paradise Canyon GR',
    address: '185 Canyon Blvd W, Lethbridge, AB T1K 6V1',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f4a3b2c1-d0e9-8765-4321-af4321098765',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Evergreen GC',
    address: '445 - 40 Ave S, Lethbridge, AB T1J 4W9',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a5b4c3d2-e1f0-8765-4321-ba5432109876',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Picture Butte GC',
    address: '608 Highway Ave, Picture Butte, AB T0K 1V0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b6c5d4e3-f2a1-8765-4321-cb6543210987',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Indian Hill GC',
    address: 'Box 100, Diamond City, AB T0K 0T0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c7d6e5f4-a3b2-8765-4321-dc7654321098',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Magrath GC',
    address: 'Box 209, Magrath, AB T0K 1J0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd8e7f6a5-b4c3-8765-4321-ed8765432109',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Lee Creek Valley GC',
    address: 'Box 249, Cardston, AB T0K 0K0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e9f8a7b6-c5d4-8765-4321-fe9876543210',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Taber GC',
    address: '4700 50 St, Taber, AB T1G 2B6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f0a9b8c7-d6e5-8765-4321-af0987654321',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Vulcan G&CC',
    address: 'PO Box 364, Vulcan, AB T0L 2B0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a1b0c9d8-e7f6-8765-4321-ba1098765432',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Crowsnest Pass GC',
    address: '10701 24 Ave, Blairmore, AB T0K 0E0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b2c1d0e9-f8a7-8765-4321-cb2109876543',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Connaught GC',
    address: '2802 - 13 Ave SE, Medicine Hat, AB T1A 3R6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c3d2e1f0-a9b8-8765-4321-dc3210987654',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Cottonwood Coulee GC',
    address: '3245 - 10 Ave SE, Medicine Hat, AB T1B 1T2',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e5f4a3b2-c1d0-8765-4321-fe5432109876',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Paradise Valley GC',
    address: '90 Gehring Rd SW, Medicine Hat, AB T1A 8L6',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f6a5b4c3-d2e1-8765-4321-af6543210987',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Brooks GC',
    address: 'PO Box 790, Brooks, AB T1R 1B7',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'a7b6c5d4-e3f2-8765-4321-ba7654321098',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Strathmore GC',
    address: '50 Ridge Rd, Strathmore, AB T1P 1B5',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'b8c7d6e5-f4a3-8765-4321-cb8765432109',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Hell\'s Creek GC',
    address: 'Raymond, AB T0K 2S0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'c9d8e7f6-a5b4-8765-4321-dc9876543210',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Waterton Lakes GC',
    address: 'Box 10, Waterton Park, AB T0K 2M0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'd0e9f8a7-b6c5-8765-4321-ed0987654321',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Nanton GC',
    address: '2401 19 Ave, Nanton, AB T0L 1R0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'e1f0a9b8-c7d6-8765-4321-fe1098765432',
    city: 'Southern Alberta',
    type: 'unknown',
    name: 'Claresholm GC',
    address: 'Box 169, Claresholm, AB T0L 0T0',
    holes: 0,
    drivingRange: 'unknown',
  },
  {
    uuid: 'f2a1b0c9-d8e7-8765-4321-af2109876543',
    city: 'Edmonton',
    type: 'public',
    name: 'de Boers Golf Shop',
    address: '5311 99 St NW, Edmonton, AB T6E 5B7',
    holes: 0,
    drivingRange: false,
  },
  {
    uuid: 'a3b2c1d0-e9f8-8765-4321-ba3210987654',
    city: 'Edmonton',
    type: 'private',
    name: 'Enbridge Centre Fitness Centre',
    address: 'Exclusive to tenants - No address displayed',
    holes: 0,
    drivingRange: false,
  },
]
